import { ApiService } from "Services/api";

export const NOTIFICATION_TYPE_INFO = "info";
export const NOTIFICATION_TYPE_CRITICAL = "critical";
export const NOTIFICATION_TYPE_SINGLE = "single_notification";

class NotificationsService {
  loadNotifications(types) {
    return ApiService.get("notification_center/messages/", {
      params: {
        type: [...types],
      },
    });
  }

  loadBellNotifications() {
    return this.loadNotifications([
      NOTIFICATION_TYPE_CRITICAL,
      NOTIFICATION_TYPE_INFO,
    ]);
  }

  loadSingleNotification() {
    return this.loadNotifications([NOTIFICATION_TYPE_SINGLE]);
  }

  markAsRead(message) {
    return ApiService.patch(`notification_center/message/${message.id}/`, {
      read: true,
    });
  }
}

const notificationsServiceInstance = new NotificationsService();

export default notificationsServiceInstance;